<template>
  <div class="history">
    <div v-for="(item, index) in items" :key="index" class="list">
      <h2>{{ showDate(item.lotto_date) }}</h2>
      <div class="prize">
        <div class="prize-box">
          <div class="p-title">1st</div>
          <div class="p-number">{{ item.results.prize_1st }}</div>
        </div>
        <div class="prize-box">
          <div class="p-title">2nd</div>
          <div class="p-number">{{ item.results.prize_2nd }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LottoService from '@/services/lottoService.js'

export default {
  name: 'HistoryResult',
  props: {
    lang: {
      type: String,
      required: true
    },
    date: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      results: []
    }
  },
  computed: {
    items() {
      return this.results
    }
  },
  watch: {
    date() {
      if(this.date) {
        this.loadResults()
      }
    }
  },
  methods: {
    loadResults() {
      LottoService.getHistories(this.lang, this.date).then((response)=>{
        if(response.status === 'success') {
          this.results = response.data
        }
      })
    },
    showDate(date) {
      return this.$moment(date).format("DD/MM/YY")
    }
  },
  mounted() {
    //this.loadResults()
  }
}
</script>
